export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    apiUrl: process.env.VUE_APP_API_URL,
  }
}
